import styled from 'styled-components';

export const Gallery = styled.div`
  position: relative;
`;

export const GalleryThumbnail = styled.div`
  position: relative;
  width: 168px;
  height: 105px;
  border-radius: 14px;
  overflow: hidden;
  cursor: pointer;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const VideoIconOverlay = styled.div`
  position: absolute;
  top: 28px;
  left: 56px;
  width: 50px;
  height: 50px;
  background-image: url('/images/shops/video.svg');
  background-repeat: no-repeat;
  background-position: center;
`;

export const ScrollButton = styled.button<{ $side: 'left' | 'right' }>`
  position: absolute;
  top: 50%;
  ${({ $side }) => ($side === 'left' ? 'left: 16px;' : 'right: 16px;')}
  transform: translateY(-50%)
    ${({ $side }) => ($side === 'left' ? '' : ' rotate(180deg)')};
  cursor: pointer;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  border: 0;
  background-image: url('/images/scroll-button.svg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: 35px;

  @media (max-width: 799px) {
    ${({ $side }) => ($side === 'left' ? 'left: 10px;' : 'right: 10px;')}
  }
`;

export const GalleryWrapper = styled.div`
  position: relative;
  display: flex;
  overflow-x: auto;
  padding: 0 40px;
  gap: 10px;
  cursor: grab;
  user-select: none;
  scroll-behavior: smooth;

  &.dragging {
    cursor: grabbing;
  }

  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: 0 15px;
  }
`;

export const ThumbnailsScrollContainer = styled.div`
  position: relative;
  width: 100%;
  margin-top: 35px;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-top: 18px;
  }
`;
